import { useEffect, useState } from 'react';
import adminService from '../services/adminService';

const CAPABILITY = 'bypass_coming_soon';

/**
 * Verifica se a sessão admin atual pode ver o site público com Coming Soon ativo.
 * Depende de login no painel (`discordAdminAuth`) + capability / owner.
 */
export default function useBypassComingSoon(comingSoonEnabled) {
  const [allowed, setAllowed] = useState(false);
  const [ready, setReady] = useState(!comingSoonEnabled);

  useEffect(() => {
    if (!comingSoonEnabled) {
      setAllowed(false);
      setReady(true);
      return undefined;
    }

    let alive = true;

    async function check() {
      setReady(false);
      if (!adminService.getAccessToken()) {
        if (alive) {
          setAllowed(false);
          setReady(true);
        }
        return;
      }

      try {
        const session = await adminService.fetchSession();
        const caps = Array.isArray(session?.capabilities)
          ? session.capabilities
          : [];
        const ok =
          Boolean(session?.isOwner) || caps.includes(CAPABILITY);
        if (alive) {
          setAllowed(ok);
          setReady(true);
        }
      } catch {
        if (alive) {
          setAllowed(false);
          setReady(true);
        }
      }
    }

    check();

    const onAuth = () => {
      check();
    };
    window.addEventListener('nexus:admin-auth', onAuth);
    window.addEventListener('storage', onAuth);

    return () => {
      alive = false;
      window.removeEventListener('nexus:admin-auth', onAuth);
      window.removeEventListener('storage', onAuth);
    };
  }, [comingSoonEnabled]);

  return { allowed, ready };
}
